import React from "react";
import {Card, CardContent} from "@mui/material";
import {InventoryCorrectionReasonLabels, inventoryCorrectionStatus} from "../../constants/securspace-constants";
import styled from "@mui/system/styled";
import {Theme} from "@mui/system";

interface Correction {
  status: string;
  reason: string;
  rejectionReason?: string;
}

interface DailyActivityItem {
  checkinCorrection?: Correction;
  checkoutCorrection?: Correction;
}

interface CorrectionStatusBarProps {
  item: DailyActivityItem;
}

type StatusBarCardProps = {
  theme?: Theme;
  status: string;
}

const StatusBarCard = styled(Card, {
  shouldForwardProp: propName => propName !== 'status'
})(({theme, status}: StatusBarCardProps) => ({
  margin: '1em 0 1em 0',
  boxShadow: 'none',
  backgroundColor: theme?.palette.success.light,
  ...(status === inventoryCorrectionStatus.PENDING && {
    backgroundColor: theme?.palette.grey[300],
  })
}));

const CorrectionStatusBar = ({item}: CorrectionStatusBarProps) => {
  const {checkinCorrection, checkoutCorrection} = item;

  const formatCorrectionReason = (reason: string): string => {
    const label = InventoryCorrectionReasonLabels.find(item => item.value === reason);
    return label?.label || reason;
  }

  const correction = checkinCorrection ?? checkoutCorrection ?? null;

  const statusBarMessage = correction?.status === inventoryCorrectionStatus.PENDING ?
    `Your Correction: ${formatCorrectionReason(correction.reason)}`
    : correction?.status === inventoryCorrectionStatus.APPROVED ?
      `Suppliers Response: Your correction has been approved.`
      : correction?.status === inventoryCorrectionStatus.REJECTED ?
        `Suppliers Response: Your correction has been rejected. Reason: ${correction?.rejectionReason}`
        : "Your correction has been cancelled"

  return <>
    {
      correction ?
        <StatusBarCard
          status={correction.status}>
          <CardContent>{statusBarMessage}</CardContent>
        </StatusBarCard>
        : ""
    }
  </>
};

export default CorrectionStatusBar;
